const contacts = [
  {social: 'email', href: 'mailto:victorjonesmesquits@gmail.com', text:'victorjonesmesquits@gmail.com'},
  {social: 'linkedin', href: 'https://www.linkedin.com/in/victor-mesquita-b6a211198/', text: "in/victor-mesquita-b6a211198"},
  {social: 'github', href: 'https://github.com/victor-joness', text: "/victor-joness"}
];

export default contacts;